export const ROUTE_BASE = "/";
export const ROUTE_SIGNUP = "/signup";
export const ROUTE_VERIFICATION = "/verification";
export const ROUTE_CHANGE_PASSWORD = "/changePassword";
export const ROUTE_NOT_FOUND = "/*";